import { useQuery } from '@tanstack/react-query';
import { listClienteLinks } from '@/services/mensagens.service';

/** Mensagens com link de um cliente — aba "Links" da galeria do perfil. */
export function useClienteLinks(clienteId: string | undefined) {
  return useQuery({
    queryKey: ['cliente-links', clienteId],
    queryFn: () => listClienteLinks(clienteId!),
    enabled: !!clienteId,
    staleTime: 60_000,
  });
}
